import React from 'react';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import { translate } from 'react-i18next';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { withRouter } from 'react-router-dom';

class OfferDelete extends React.Component {
  handleDelete = () => {
    const {firebase, user} = this.props;
    if (!this.props.offerKey) return;
    const offerRef = firebase.database().ref(`shopkeepers/${user.shopkeeperId}/offers/${this.props.offerKey}`);
    offerRef.remove();

    if (this.props.couponCode) {
      firebase.database()
        .ref(`couponCodes/${this.props.couponCode}`)
        .remove();
    }
    this.props.history.replace('/offers');
  }
  handleClose = () => {
    this.props.handleClose();
  }

  render()  {
    const {t} = this.props;
    const actions = [
      <FlatButton
        label={t('cancel')}
        onTouchTap={this.handleClose}
      />,
      <RaisedButton
        label={t('offer.delete')}
        primary={true}
        onTouchTap={this.handleDelete}
      />,
    ];

    return (
      <Dialog title={t('offer.delete')}
        open={this.props.open}
        onRequestClose={this.handleClose}
        actions={actions}>
        {t('offer.deleteDialogText') + ' ' + this.props.offerName + '?'}
      </Dialog>

    );
  }
}

const enhance = compose(translate(), firebase, user, withRouter);

export default enhance(OfferDelete);



// WEBPACK FOOTER //
// ./src/Offer/OfferDelete.js